import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { useApiStore } from "@/stores/api"

export const useMarkerStore = defineStore(
	"marker",
	() => {
		const api = useApiStore()
		const markers = ref([])

		const reset = () => {
			markers.value = []
		}

		const loadMarkers = async () => {
			const response = await api.dispatchApiCall("get", `/api/v2/markers`)
			if (!response) {
				return false
			}
			markers.value = response.data
			return true
		}

		const createMarker = async (data) => {
			return api.dispatchApiCall("post", `/api/v2/markers`, data)
		}

		const updateMarker = async (data) => {
			return api.dispatchApiCall("patch", `/api/v2/markers/${data.id}`, data)
		}

		const deleteMarker = async (markerId) => {
			return api.dispatchApiCall("delete", `/api/v2/markers/${markerId}`)
		}

		/* access helpers */

		const markersById = computed(() => {
			let returnArray = []
			markers.value.forEach((marker) => {
				returnArray[marker.id] = marker
			})
			return returnArray
		})

		const markersWithoutMarkercategory = computed(() => {
			return markers.value.filter((marker) => !marker.marker_category_ids || marker.marker_category_ids.length === 0)
		})

		return {
			reset,
			markers,
			markersById,
			loadMarkers,
			createMarker,
			updateMarker,
			deleteMarker,
			markersWithoutMarkercategory,
		}
	},
	{
		persist: true,
	}
)
